import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import FlashLib from 'flashlib_onlyplay';
import animationTypes from '../animations/animationTypes';
import animationCreator from 'Engine/animations/animationCreator';
import eSymbolIndex from './eSymbolIndex';

export default class SymbolAnimation extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);
    this.animationNames = {
      [eSymbolIndex.ESI_COOKIE]: 'cookie',
      [eSymbolIndex.ESI_SNOWMAN]: 'snowman',
      [eSymbolIndex.ESI_BELL]: 'bells',
      [eSymbolIndex.ESI_TOY]: 'toy',
      [eSymbolIndex.ESI_CUP]: 'cup',
      [eSymbolIndex.ESI_POMEGRANATE]: 'pomegranate',
      [eSymbolIndex.ESI_ORANGE]: 'orange',
      [eSymbolIndex.ESI_GRAPES]: 'grape',
      [eSymbolIndex.ESI_PINEAPPLE]: 'pineapple',
      [eSymbolIndex.ESI_BONUS]: 'box_red',
      [eSymbolIndex.ESI_BONUS_MINI]: 'box_mini',
      [eSymbolIndex.ESI_BONUS_MAJOR]: 'box_major',
      [eSymbolIndex.ESI_BONUS_GRAND]: 'box_grand',
    };

    this.idleAnimationNames = {
      [eSymbolIndex.ESI_BONUS_MINI]: 'box_mini_idle',
      [eSymbolIndex.ESI_BONUS_MAJOR]: 'box_major_idle',
      [eSymbolIndex.ESI_BONUS_GRAND]: 'box_grand_idle',
    };

    this.stopAnimationNames = {
      [eSymbolIndex.ESI_COOKIE]: 'cookie_stop',
      [eSymbolIndex.ESI_BONUS]: 'box_red_stop',
      [eSymbolIndex.ESI_BONUS_MINI]: 'box_grand_stop',
      [eSymbolIndex.ESI_BONUS_MAJOR]: 'box_grand_stop',
      [eSymbolIndex.ESI_BONUS_GRAND]: 'box_grand_stop',
    };

    this.onComplete = () => {};
    this.onStart = () => {};

    this.animationListener = {
      start: () => {
        this.onStart();
      },
      complete: () => {
        this._complete(this)
      }
    };

    this.animation = null;
    this.init();
    this.addListeners();
  }

  init() {
    this.animation = animationCreator.createAnimation(animationTypes.SYMBOLS);
    this.animation.visible = false;
    this.animation.state.addListener(this.animationListener);
    this.addChild(this.animation);
  }

  addListeners() {
    GlobalDispatcher.add('stateStart:jackpotGameInState', () => this.isActive = this.animation.visible, this);
    GlobalDispatcher.add('stateStart:jackpotGameOutState', () => this.animation.visible = this.isActive, this);
  }

  start(loop) {
    this._playSpineAnimation(loop);
  }

  _playSpineAnimation(loop) {
    this.animation.visible = true;
    this.animation.state.setAnimation(0, this.animationNames[this.id], loop);

    if (!loop && this.idleAnimationNames[this.id]) {
      this.animation.state.addAnimation(0, this.idleAnimationNames[this.id], true, 0);
    }
  }

  startStopAnimation() {
    this.animation.visible = true;
    this.animation.skeleton.setToSetupPose();
    this.animation.state.setAnimation(0, this.stopAnimationNames[this.id], false);
  }

  startIdleAnimation() {
    if (this.idleAnimationNames[this.id]) {
      this.animation.visible = true;
      this.animation.state.setAnimation(0, this.idleAnimationNames[this.id], true);
    }
  }

  _complete() {
    // this.animation.visible = false;
    this.onComplete();
    // this.emit('animationComplete', this);
  }

  stop() {
    if (this.animation) {
      this.animation.visible = false
    }
  }
}
